/*
 ** Header
 */

const wiehag_header_config = {
  elements: [
    { 'modal-incoming-packages-queue': true, title: 'incomingPackagesbtn', size: 'incomingPackagesSize', isList: true },
    { 'modal-created-packages-queue': true, title: 'createdPackagesbtn', size: 'createdPackagesSize', isList: true },
    { 'modal-packages-queue': true, title: 'loadedPackagesbtn', size: 'packageLoadedSize', isList: true },
    { 'modal-material-needed': true, title: 'materialNeededbtn', size: 'materialNeededSize', isList: true },
    { 'modal-errors-list': true, title: 'errorlistbtn', size: 'errorsListSize', isList: true },
    { 'modal-jd-queue': true, title: 'layersqueuebtn', size: 'layersQueueSize', isList: true },
    { 'modal-orders-queue': true, title: 'ordersqueuebtn', size: 'ordersQueueSize', isList: true }
  ],
  errorView: false,
  viewToggle: false
};

export default wiehag_header_config;
